import { REQUEST_METHOD } from '../../middlewares/services';

import * as types from './types';
import { endpoint } from '../../../config/const';

const myReferrals = (data) => ({
    type: types.MY_REFERRALS,
    meta: {
        endpoint: endpoint.MY_REFERRALS,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
 
export default {
    myReferrals, 
}